<template>
  <div class="submit-form-container">
    <div class="hiringStand form-informations">
      <h1 class="title">2018“决战港股”系列峰会合作申请表</h1>
      <p class="introduction">
        <span>
          活动时间:
        </span>
        2018年11月-12月</p>
      <p class="introduction">
        <span>
          活动地址:
        </span>
        <span v-for="item in hiringStandAdress" :key="item">{{item}}</span>
      </p>
      <p class="introduction">
        <span>
          观众构成:
        </span>
        上市公司高层、金融机构代表、数十家国内主流媒体、劵商、银行、私募、公募等金融机构投资
        者、高净值个人投资者以及资深分析师</p>
      <p class="introduction">
        <span>
          合作咨询:
        </span>
        Dora 刘</p>
      <p class="introduction">
        <span>
          手机:
        </span>
        13697925994</p>

      <div class="info-box">
        <label class="label" for="name">合作形式
          <span class="data-form-required"> * </span>
        </label>
        <el-checkbox-group class="checkbox" v-model="form.cooperateWayArry">
          <el-checkbox label="展位合作"></el-checkbox>
          <el-checkbox label="媒体申请"></el-checkbox>
          <el-checkbox label="礼品赞助"></el-checkbox>
          <el-checkbox label="其他合作"></el-checkbox>
        </el-checkbox-group>
        <label class="label" for="company-name">您的公司名称
          <span class="data-form-required"> * </span>
        </label>
        <el-input class="input" v-model='form.companyName' size='medium' />
        <label class="label" for="contact-person">联系人
          <span class="data-form-required"> * </span>
        </label>
        <el-input class="input" v-model='form.contactPerson' size='medium' />
        <label class="label" for="position">职位
          <span class="data-form-required"> * </span>
        </label>
        <el-input class="input" v-model='form.position' size='medium' />
        <label class="label" for="phone-number">手机号
          <span class="data-form-required"> * </span>
        </label>
        <el-input class="input" prefix-icon='el-icon-mobile-phone' v-model='form.phoneNumber' size='medium' />
        <label class="label" for="wechat">微信
          <span class="data-form-required"> * </span>
        </label>
        <el-input class="input" v-model='form.wechat' size='medium' />
        <label class="label" for="email">邮箱E-mail
          <span class="data-form-required"> * </span>
        </label>
        <el-input class="input" prefix-icon='el-icon-message' v-model='form.email' size='medium' />
        <label class="label" for="provide-resources">您能提供的资源有哪些，请逐一描述！
          <!-- <span class="data-form-required"> * </span> -->
        </label>
        <p>如展位申请可忽略此项！</p>
        <el-input class="input" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model='form.provideResources'
          size='medium' />
        <label class="label" for="demand">您希望在本次大会上面获取到哪些曝光及合作点，请进行描述！
          <span class="data-form-required"> * </span>
        </label>
        <el-input class="input" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model='form.demand' size='medium' />
      </div>
      <el-button class="hiring-stand-button" @click="submitData" type="primary">提交</el-button>
    </div>
  </div>
</template>

<script>
  import {
    Toast,
    Indicator,
    MessageBox
  } from "mint-ui";
  export default {
    data() {
      return {
        hiringStandAdress: [],
        form: {
          activeType: 'hkstock',
          timeId: new Date().getFullYear(),
          cooperateWayArry: [],
          cooperateWay: '',
          companyName: '',
          contactPerson: '',
          position: '',
          phoneNumber: '',
          wechat: '',
          email: '',
          provideResources: '',
          demand: '',
        }
      }
    },
    methods: {
      getData() {
        this.$http.enroll_hkstocks_city_list().then(res => {
          console.log(res.data.result)
          res.data.result.forEach(item => {
            console.log(item)
            this.hiringStandAdress.push(item.city)
          })
        });
      },
      submitData() {
        if (this.form.phoneNumber.length !== 11 && this.form.phoneNumber.length !== 8) {
          Toast({
            message: "请输入8位香港手机号,或者11位大陆手机号~",
            iconClass: "icon el-icon-warning"
          });
          return;
        }
        for (let key in this.form) {
          switch (key) {
            case 'provideResources':
              break;
            case 'demand':
              break;
            case 'cooperateWay':
              break;
            default:
              if (!this.form[key] === true) {
                console.log(key)
                Toast({
                  message: "报名信息不全~",
                  iconClass: "icon el-icon-warning"
                });
                return false;
              }
              break;
          }
        }
        this.form.cooperateWay = this.form.cooperateWayArry.toString()
        this.$http
          .addCooperateEnroll({
            ...this.form
          })
          .then(res => {
            if (res.data.statusCode === 200) {
              //首次报名报名
              Toast({
                message: "已报名成功!请留意后续资料审核通知",
                iconClass: "icon el-icon-success",
                duration: 5000
              });
              setTimeout(() => {
                window.close();
              }, 5500);
            } else {
              Toast({
                message: '报名错误，请稍后重试或联系工作人员',
                iconClass: "icon el-icon-warning",
                duration: 5000
              });
            }
          });
      },
    },
    created() {
      this.getData()
    },

  }

</script>

<style scoped>
  .submit-form-container {
    /* background: url(https://asset.mikecrm.com/getimg/origin/images/formTemplate/img-bmsq-0-0.jpg)
    repeat; */
    height: auto;
    display: block;
    width: 100%;
    position: absolute;
    font-size: 14px;
    background-color: #f1f1f1;
    min-height: 100vh;
  }

  .form-informations {
    max-width: 560px;
    width: 100%;
    background: #fff;
    margin: 0 auto;
    min-height: 100vh;
    margin-top: 30px;
    margin-bottom: 30px;
    box-shadow: 1px 2px 8px 3px rgba(59, 59, 59, 0.123);
    padding: 20px;
    box-sizing: border-box;
  }

  @media (max-width: 960px) {
    .form-informations {
      max-width: 560px;
      width: 100%;
      background: #fff;
      margin: 0 auto;
      box-shadow: 1px 2px 8px 3px rgba(59, 59, 59, 0.123);
      min-height: 100vh;
      padding: 20px;
    }
  }

  h1 {
    font-size: 1.833em;
    color: #000;
    font-weight: normal;
  }

  .introduction {
    color: rgb(105, 105, 105);
    margin: 20px 0;
    font-size: .9em;
  }

  .introduction>span {
    margin-right: 5px;
  }

  .info-box {
    padding-top: 20px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
  }

  .checkbox {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
  }

  .checkbox>label {
    margin: 0;
  }

  .input {
    margin-bottom: 30px;
  }

  .label {
    font-weight: bold
  }

  .data-form-required {
    color: red;
  }

  .hiring-stand-button {
    margin: 0 auto;
    display: block;
    border: 0;
    padding: 10px 70px;
    border-radius: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/frontend/hiringStand.vue